import Axios, { AxiosError, AxiosResponse } from "axios";

const API = Axios.create();
API.interceptors.response.use(
  (response: AxiosResponse) => {
    const apitime = new Date(localStorage.getItem("API_TIME") as string) || new Date();
    const endDate = new Date();
    const seconds = (endDate.getTime() - (apitime?.getTime() || new Date().getTime())) / 1000;

    if (60 * 60 < seconds) {
      localStorage.clear();
      if (!window.location.href.includes("signin")) {
        window.location.replace("/signin");
      }
    } else {
      localStorage.setItem("API_TIME", new Date().toString());
    }
    return response;
  },
  (error: AxiosError) => {
    const { status } = error.response as AxiosResponse;
    if (status === 401) {
      localStorage.clear();
      if (!window.location.href.includes("signin")) {
        window.location.replace("/signin");
      }
    }
    return Promise.reject(error);
  }
);
export default API;
